import React, {Component} from 'react';
import ClassNames from 'classnames';

class NewSocialMedia extends Component {
    
    constructor(props) {
        super(props);
    }
    
    
    render() {
        const {titleHead} = this.props.configInformation;
        const socials = this.props.configInformation.socials?.filter(e=>e.url?? false);
        const show = socials.some(x => x.url);
        return (
            <div className="social-media">
                {show &&
                    <div>
                        {titleHead && (
                            <h3 dangerouslySetInnerHTML={{__html: titleHead}}/>
                        )}
                        {show &&
                            <div className="informationDetail informationDetailHeader ">
                                <ul>
                                    {socials.map(({url, socialIcon, onClick}, index) => url &&
                                        <li style={{width:100/socials.length+"%"}} onClick={onClick} key={"sm-"+index}>
                                            <a key={index} className={""}
                                               href={url ? url : "#"} target="_blank" rel="nofollow">
                                                <span className={ClassNames(socialIcon)}/>
                                            </a>
                                        </li>
                                    )}
                                </ul>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

export default NewSocialMedia;
